import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const resource = '/admin/customer/industrial_sectors'

export default {
  getListOfIndustrialSectors(filterQuery){
    return Repository.get(`/admin/customer/industrial_sector?${filterQuery}`)
  },
  createIndustrialSector(payload){
    return Repository.post(`${resource}`,payload)
  },
  deleteIndustrialSector(id){
    return Repository.delete(`${resource}/${id}`)
  },
  getIndustrialSector(id){
    return Repository.get(`${resource}/${id}`)
  },
  updateIndustrialSector(id, payload){
    return Repository.put(`${resource}/${id}`, payload)
  }

}
